import React, { useEffect, useMemo, useState } from 'react';
import { getDashboardTests } from './api';

/* Dashboard Component
   2026-01-12 Initial design
*/

const defaultEventChecks = [
 {
    name: 'Event Setup',
    status: 'warning',
    lastRun: '2025-03-22 09:41',
    checks: [
      { name: 'Placeholder data while database queried', status: 'warn' },
    ],
  },
];

const defaultSuites = [
  {
    name: 'Database checks',
    status: 'warning',
    lastRun: '2025-03-22 09:41',
    checks: [
      { name: 'Placeholder data while database queried', status: 'warn' },
    ],
  },
];

const Dashboard = () => {
  const [statusFilter, setStatusFilter] = useState('all');
  const [query, setQuery] = useState('');
  const [eventChecks, setEventChecks] = useState(defaultEventChecks);
  const [testSuites, setTestSuites] = useState(defaultSuites);

  useEffect(() => {
    let mounted = true;

    const fetchDashboard = () => {
      getDashboardTests()
        .then((data) => {
          if (!mounted || !data) return;
          if (Array.isArray(data.event_checks)) {
            setEventChecks(data.event_checks);
          }
          if (Array.isArray(data.suites)) {
            setTestSuites(data.suites);
          }
        })
        .catch(() => {});
    };

    fetchDashboard();
    const interval = setInterval(fetchDashboard, 30000);

    return () => {
      mounted = false;
      clearInterval(interval);
    };
  }, []);

  const filteredEventChecks = useMemo(() => {
    return eventChecks.filter((eventCheck) => {
      const matchesStatus = statusFilter === 'all' || eventCheck.status === statusFilter;
      const matchesQuery =
        query.trim().length === 0 ||
        (eventCheck.name || '').toLowerCase().includes(query.toLowerCase()) ||
        (eventCheck.status || '').toLowerCase().includes(query.toLowerCase()) ||
        (eventCheck.checks || []).some((check) =>
          (check.name || '').toLowerCase().includes(query.toLowerCase())
        );
      return matchesStatus && matchesQuery;
    });
  }, [eventChecks, query, statusFilter]);

  const counts = useMemo(() => {
    return eventChecks.reduce(
      (acc, event_check) => {
        acc.total += 1;
        acc[event_check.status] += 1;
        return acc;
      },
      { total: 0, open: 0, monitoring: 0, resolved: 0 }
    );
  }, [eventChecks]);


  return (
    <div className="dashboard">
      <div className="dashboard-header">
        <div>
          <h2>Race Backend Dashboard</h2>
          <div className="dashboard-subtitle">
            Test for known issues in setup and raceday results.
          </div>
        </div>
        {/* <div className="dashboard-metrics">
          <div className="metric">
            <div className="metric-label">Issues</div>
            <div className="metric-value">{counts.total}</div>
          </div>
          <div className="metric">
            <div className="metric-label">Open</div>
            <div className="metric-value">{counts.open}</div>
          </div>
          <div className="metric">
            <div className="metric-label">Monitoring</div>
            <div className="metric-value">{counts.monitoring}</div>
          </div>
        </div>
      </div>

      <div className="dashboard-controls">
        <input
          className="dashboard-search"
          type="text"
          value={query}
          placeholder="Search issues by ID, area, or title"
          onChange={(event) => setQuery(event.target.value)}
        />
        <div className="dashboard-filters">
          {['all', 'open', 'monitoring', 'resolved'].map((status) => (
            <button
              key={status}
              type="button"
              className={`filter-chip ${statusFilter === status ? 'active' : ''}`}
              onClick={() => setStatusFilter(status)}
            >
              {status}
            </button>
          ))}
        </div> */}
      </div>

      <div className="dashboard-grid">
        <section className="panel">
          <div className="panel-header">
            <h3>Event Tests</h3>
            <span className="panel-meta">{filteredEventChecks.length} shown</span>
          </div>
          <div className="suite-list">
            {filteredEventChecks.map((suite) => (
              <div key={suite.name} className={`suite-card suite-${suite.status.substring(0,4)}`}>
                <div className="suite-header">
                  <div>
                    <div className="suite-title">{suite.name}</div>
                    <div className="suite-meta">{suite.lastRun}</div>
                  </div>
                  <span className={`pill status-${suite.status.substring(0,4)}`}>{suite.status}</span>
                </div>
                <ul className="suite-checks">
                  {suite.checks.map((check) => (
                    <li key={check.name} className={`check-row check-${check.status}`}>
                      <span>{check.name}</span>
                      <span className="check-status">{check.status}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>

        <section className="panel">
          <div className="panel-header">
            <h3>Race-Day Tests</h3>
            <span className="panel-meta">Latest run snapshots</span>
          </div>
          <div className="suite-list">
            {testSuites.map((suite) => (
              <div key={suite.name} className={`suite-card suite-${suite.status.substring(0,4)}`}>
                <div className="suite-header">
                  <div>
                    <div className="suite-title">{suite.name}</div>
                    <div className="suite-meta">Last run: {suite.lastRun}</div>
                  </div>
                  <span className={`pill status-${suite.status.substring(0,4)}`}>{suite.status}</span>
                </div>
                <ul className="suite-checks">
                  {suite.checks.map((check) => (
                    <li key={check.name} className={`check-row check-${check.status}`}>
                      <span>{check.name}</span>
                      <span className="check-status">{check.status}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </section>
      </div>
    </div>
  );
};
export default Dashboard;
